import { calendarDaysBetween } from '../ai/topic-planner.js';
/**
 * Yearly theme grid (spec 110 section 4 `theme_slots`, S110-7): a slot holds a
 * period of tenant calendar days, a pillar of the property, a theme (content
 * the human wrote, never UI text) and an optional campaign. The API validates
 * with these numbers; the web's editor uses the same ones for its hints.
 */
export const THEME_SLOT_LIMITS = {
    themeMaxLength: 120,
    /** `period_end - period_start` in days, the migration's CHECK (a slot never spans more than a year). */
    maxPeriodDays: 366,
    /** Ideas one request creates from a slot; an idea stays an idea until a human moves it on. */
    maxIdeasPerRequest: 5,
    /** Slots one listing returns (one property and one year hold far fewer). */
    maxListed: 500,
    minYear: 2000,
    maxYear: 2100,
};
/**
 * Period problems of a slot (both are tenant calendar days, `YYYY-MM-DD`):
 * `period_end` before `period_start`, or a span above `maxPeriodDays`.
 */
export function themeSlotPeriodProblems(periodStart, periodEnd) {
    if (periodEnd < periodStart)
        return [{ field: 'period_end', code: 'before_period_start' }];
    if (calendarDaysBetween(periodStart, periodEnd) > THEME_SLOT_LIMITS.maxPeriodDays)
        return [{ field: 'period_end', code: 'period_too_long' }];
    return [];
}
//# sourceMappingURL=theme-slots.js.map